<ce-icon [svgIcon]="statusBoxIcon() ? statusBoxIcon()! : 'error-3'" ce-icon-xs [attr.aria-hidden]="true" />
@if (label()) {
<div class="CeStatusBox-label u-text-body-sm">{{ label() }}</div>
}
